import axios from "axios";
import Swal from 'sweetalert2'
import "../components/swalStyle/customStyle.css";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice")

const URL = process.env;

const instance = getInstance()

export const getRole = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const rs = await instance.get(`/api/role`, {
            headers:headers,
            params: {...queryparams}
        })

        if(rs.data.status.toLowerCase() == 'success') {
            return rs
        }else{
            throw new Error(`error durring fetch api`)
        }
    }catch(error) {
        throw error
    }
};
export const getRoleByID = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.get(`/api/role/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
  };
export const getAllRole = async (queryparams) => {
    try{
        const rs = await instance.get(`/api/role/menu`, {
            params: {...queryparams}
        })

        if(rs.data.status.toLowerCase() == 'success') {
            return rs
        }else{
            throw new Error(`error durring fetch api`)
        }
    }catch(error) {
        throw error
    }
};
export const createRole = async (body) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.post(`/api/role`, body, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};
export const updateRoleByID = async (id, body) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.put(`/api/role/${id}`, body, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const deleteRole = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/role/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};